export const getters = {
  ofs: ({ ofs }) => ofs,
}
